import { useEffect, useState } from 'react';
import { LinearProgress } from '@mui/material';
import { useRouteLoading } from '@/utils/routeLoading';

// Most page chunks arrive in well under this; a bar that flashes for 40 ms on
// every click is noise, not feedback.
const SHOW_AFTER_MS = 150;

/**
 * A thin bar across the top of the window while a page's code downloads for
 * the first time (see utils/routeLoading.js) — the same signal the content
 * area's "Loading page..." gives, visible wherever the user is looking.
 */
export default function RouteProgressBar() {
  const loading = useRouteLoading();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!loading) {
      setVisible(false);
      return undefined;
    }

    const timer = setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  if (!visible) return null;

  return (
    <LinearProgress
      aria-label="Loading page"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: (theme) => theme.zIndex.tooltip + 1,
        bgcolor: 'transparent',
      }}
    />
  );
}
